import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router"; 
import { DashboardComponent } from "./dashboard/dashboard.component";
import { RecruiterComponentsComponent } from "./recruiter-components.component";
import { CommonRecuriterComponent } from "../shared/common-recuriter";
import { JobPostComponent } from "./job-post/job-post.component";
import { AddPostComponent } from "./job-post/add-post/add-post.component";
import { StepOneComponent } from "./job-post/add-post/step-one/step-one.component";
import { PostJobComponent } from "./job-post/post-job/post-job.component";
import { JobTemplateComponent } from "./job-post/job-template/job-template.component";
import { DetailsComponent } from "./job-post/details/details.component";
import { SearchComponent } from "./search/search.component";
import { UsersComponent } from "./users/users.component";
import { UserDetailComponent } from "./users/user-detail/user-detail.component";
import { AddEditUserComponent } from "./users/add-edit-user/add-edit-user.component";
import { GroupsComponent } from "./groups/groups.component";
import { AddGroupComponent } from "./groups/add-group/add-group.component";
import { ManageUsersComponent } from "./groups/manage-users/manage-users.component";
import { AddUsersGroupComponent } from "./groups/add-users-group/add-users-group.component";
import { PreviewComponent } from "./job-post/add-post/preview/preview.component";
import { SuggestedJobComponent } from "./job-post/suggested-job/suggested-job.component";
import { ApplicantJobComponent } from "./job-post/applicant-job/applicant-job.component";
import { MessageComponent } from "./message/message.component";
import { DetailComponent } from "./job-post/applicant-job/detail/detail.component";
import { NotesComponent } from "./job-post/applicant-job/notes/notes.component";
import { ActivityComponent } from "./job-post/applicant-job/activity/activity.component";
import { MessageDetailComponent } from "./message/message-detail/message-detail.component";
import { ArchivedComponent } from "./users/archived/archived.component";
import { CandidatesComponent } from "./candidates/candidates.component";
import { SkippedComponent } from "./candidates/skipped/skipped.component";
import { SaveSearchComponent } from "./search/save-search/save-search.component";
import { ProfileComponent } from "./profile/profile.component";
import { AccountSettingsComponent } from "./account-settings/account-settings.component";
import { ChangePasswordComponent } from "./account-settings/change-password/change-password.component";
import { NotificationComponent } from "./account-settings/notification/notification.component";
import { SaveCardComponent } from "./account-settings/save-card/save-card.component";
import { SubscriptionComponent } from "./account-settings/subscription/subscription.component";
import { BillingAddressComponent } from "./account-settings/billing-address/billing-address.component";
import { MyTemplatesComponent } from "./account-settings/my-templates/my-templates.component";
import { InventoryHistoryComponent } from "./account-settings/inventory-history/inventory-history.component";
import { InventoryPlanComponent } from "./account-settings/inventory-history/inventory-plan/inventory-plan.component";
import { SubscriptionPlanComponent } from "./account-settings/subscription/subscription-plan/subscription-plan.component";
import { CheckoutComponent } from "./account-settings/checkout/checkout.component";
import { ShareButtonComponent } from "./job-post/applicant-job/share-button/share-button.component";
import { NotificationManagementComponent } from "./notification-management/notification-management.component";
import { SearchDetailComponent } from "./search/search-detail/search-detail.component";
import { SearchNotesComponent } from "./search/search-notes/search-notes.component";
import { SearchAcitivityComponent } from "./search/search-acitivity/search-acitivity.component";
import { EditComponent } from "./profile/edit/edit.component";
import { ReportsComponent } from "./reports/reports.component";
import { SerachReportComponent } from "./reports/serach-report/serach-report.component";
import { InventoryUsageComponent } from "./reports/inventory-usage/inventory-usage.component";
import { JobReportComponent } from "./reports/job-report/job-report.component";
import { UserActivityComponent } from "./reports/user-activity/user-activity.component";
import { HelpComponent } from "./help/help.component";
import { ConfirmationScreenComponent } from "./confirmation-screen/confirmation-screen.component";

const routes: Routes = [
  { path: "", component: RecruiterComponentsComponent,
     children:[
      { path: "confirmation-screen", component: ConfirmationScreenComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "jobs", component: CommonRecuriterComponent,
        children:[
          { path: "", component: JobPostComponent },
          { path: "detail/:id", component: DetailsComponent },
          { path: "suggested/:id", component: CommonRecuriterComponent,
            children:[
              {path: "", component: SuggestedJobComponent},
              {path: "appdetail", component: DetailComponent},
              {path: "share", component: ShareButtonComponent},
              {path: "notes/:id", component: NotesComponent},
              {path: "activity/:id", component: ActivityComponent},
            ],
          },
          { path: "applicant/:id", component: CommonRecuriterComponent,
            children:[
              {path: "", component: ApplicantJobComponent},
              {path: "appdetail", component: DetailComponent},
              {path: "share", component: ShareButtonComponent},
              {path: "notes/:id", component: NotesComponent},
              {path: "activity/:id", component: ActivityComponent},
            ],
          },
          { path: "post-job", component: PostJobComponent},
          { path: "template/:id", component: JobTemplateComponent},
          { path: "add", component: AddPostComponent},
          { path: "edit", component: AddPostComponent}, 
          { path: "prev/:id", component: PreviewComponent}, 
        ]
      },
      { path: "message", component: CommonRecuriterComponent,
      children: [
          { path: "", component: MessageComponent },
          { path: "message-detail/:id", component: MessageDetailComponent }
        ]
      }, 
      { path: "search", component: CommonRecuriterComponent,
      children: [
          { path: "", component: SearchComponent },
          { path: "save-search", component: SaveSearchComponent },
          {path: "detail/:id", component: SearchDetailComponent},
          {path: "notes/:id", component: SearchNotesComponent},
          {path: "activity/:id", component: SearchAcitivityComponent},
        ]
      }, 
      { 
        path: "users", component: CommonRecuriterComponent,
        children: [
          { path: "", component: UsersComponent },
          { path: "detail/:id", component: UserDetailComponent },
          { path: "add", component: AddEditUserComponent },
          { path: "edit/:id", component: AddEditUserComponent },
        ]
      },
      { 
        path: "archived", component: CommonRecuriterComponent,
        children: [ 
          { path: "", component: ArchivedComponent },
          { path: "detail/:id", component: UserDetailComponent },
          { path: "add", component: AddEditUserComponent },
          { path: "edit/:id", component: AddEditUserComponent },
        ]
      },
      {
        path: "groups", component: CommonRecuriterComponent,
        children:[
          { path: "", component: GroupsComponent },
          { path: "add", component: AddGroupComponent },
          { path: "manage-users/:id", component: ManageUsersComponent },
          { path: "manage-users/:id/add-users-group/:grpPerId", component: AddUsersGroupComponent },
        ]
      },
      {
        path: "candidates", component: CommonRecuriterComponent,
        children:[
          { path: "", component: CandidatesComponent },
          { path: "skipped", component: SkippedComponent },
          { path: "manage-users/:id", component: ManageUsersComponent },
        ]
      }, 
      {
        path: "profile", component: CommonRecuriterComponent,
        children:[
          { path: "", component: ProfileComponent },
          { path: "edit", component: EditComponent }, 
        ]
      },  
      {
        path: "account-settings", component: CommonRecuriterComponent,
        children:[
          // { path: "", component: AccountSettingsComponent },
          { path: "", component: ChangePasswordComponent },
          { path: "change-password", component: ChangePasswordComponent }, 
          { path: "notification", component: NotificationComponent },  
          { path: "save-card", component: SaveCardComponent },  
          { path: "save-card", component: SaveCardComponent },  
          { path: "subscription", component: CommonRecuriterComponent,
            children:[
              { path: "", component: SubscriptionComponent },
              { path: "subscription-plan", component: SubscriptionPlanComponent },
            ]
          },  
          { path: "inventory-history",  component: CommonRecuriterComponent,
            children:[
              { path: "", component: InventoryHistoryComponent },
              { path: "inventory-plan", component: InventoryPlanComponent }, 
            ] 
          },  
          { path: "checkout/:from/:id", component: CheckoutComponent },  
          { path: "billing-address", component: BillingAddressComponent },  
          { path: "my-templates", component: MyTemplatesComponent },  
        ]
      }, 
      {
        path: "report", component: CommonRecuriterComponent,
        children:[
          { path: "", component: ReportsComponent },
          { path: "user-activity", component: UserActivityComponent }, 
          { path: "serach-detail", component: SerachReportComponent }, 
          { path: "inventory-usage", component: InventoryUsageComponent },  
          { path: "job-report", component: JobReportComponent },   
        ]
      }, 
      { path: "notification", component: NotificationManagementComponent },
      { path: "help", component: HelpComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecruiterComponentRoutingModule { }
